// @flow

import { createReducer } from 'redux-act';

import type { State } from '../types';

import {
  type SaveDraftContactParams,
  saveOneDraftContact,
  cleanUpAllDrafts,
} from './actions';

const initialState: State = {
  drafts: {
    create: undefined,
    transfer: undefined,
  },
};

export default (createReducer(
  {
    // $FlowFixMe[invalid-computed-prop]
    [saveOneDraftContact]: (
      state: State,
      params: SaveDraftContactParams,
    ): State => ({
      ...state,
      // $FlowFixMe[incompatible-indexer] TODO: Fix type
      drafts: {
        ...state.drafts,
        // $FlowFixMe[invalid-computed-prop]
        [params.process]: {
          ...state.drafts[params.process],
          // $FlowFixMe[invalid-computed-prop]
          [params.role]: params.contact,
        },
      },
    }),
    // $FlowFixMe[invalid-computed-prop]
    [cleanUpAllDrafts]: (): State => initialState,
  },
  initialState,
): {
  (): (state: State, payload?: mixed, meta?: mixed) => State,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<State>,
  options: () => mixed,
  ...
});
